import { PdfJobEventSchema } from "../models/itinerary-pdf-job.schema";
function dispatchLine(data, callbacks) {
    let parsed;
    try {
        parsed = JSON.parse(data);
    }
    catch (parseError) {
        callbacks.onError?.(parseError instanceof Error
            ? parseError
            : new Error(`PDF job SSE parse error: ${String(parseError)}`));
        return;
    }
    const result = PdfJobEventSchema.safeParse(parsed);
    if (!result.success) {
        callbacks.onError?.(new Error(`PDF job SSE payload failed validation: ${result.error.message}`));
        return;
    }
    callbacks.onStatusChange?.(result.data);
}
/**
 * Process a ReadableStream of `pdf_job.status_changed` SSE events.
 *
 * Format: lines starting with "data: " followed by JSON. Lines starting
 * with ":" are heartbeat/ping comments and are ignored, as are blank lines.
 */
export async function processPdfJobStream(stream, callbacks) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    try {
        let done = false;
        while (!done) {
            const result = await reader.read();
            done = result.done;
            if (done)
                break;
            buffer += decoder.decode(result.value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop() ?? "";
            for (const line of lines) {
                const trimmed = line.trim();
                if (!trimmed || trimmed.startsWith(":"))
                    continue;
                if (trimmed.startsWith("data: ")) {
                    dispatchLine(trimmed.slice(6), callbacks);
                }
            }
        }
        const trimmed = buffer.trim();
        if (trimmed.startsWith("data: ")) {
            dispatchLine(trimmed.slice(6), callbacks);
        }
    }
    catch (error) {
        callbacks.onError?.(error instanceof Error ? error : new Error(`PDF job stream error: ${String(error)}`));
    }
    finally {
        reader.releaseLock();
    }
}
export const pdfJobStreamService = {
    processPdfJobStream,
};
export default pdfJobStreamService;
